module.exports = __webpack_public_path__ + "static/media/BoxPlotQ2_1.b049b270.svg";